import { OPEN_TERMS_MODAL, CLOSE_TERMS_MODAL } from "./actionTypes";

function openTermsModal(informativeMode?: boolean) {
  return {
    type: OPEN_TERMS_MODAL,
    informativeMode
  };
};

function closeTermsModal() {
  return {
    type: CLOSE_TERMS_MODAL,
  };
};

export {
  openTermsModal,
  closeTermsModal
}